import {
    faBars,
    faChevronLeft,
    faUserPlus,
    faSignInAlt,
    faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ThemeToggle from "../theme/theme-toggle";
import Bell from "./BellNoti";
import MainMenu from "../pages/Home/MainMenu";

function Header({ hasBackButton, redirectPath }) {
    const { isLogined, userInfo } = useSelector((state) => state.auth);
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [isChecking, setIsChecking] = useState(true);
    const navigate = useNavigate();
    const pathName = window.location.pathname;

    useEffect(() => {
        const hasToken = !!localStorage.getItem("access_token");
        if (hasToken) {
            if (isLogined) {
                setIsChecking(false);
            } else {
                const timer = setTimeout(() => setIsChecking(false), 1000);
                return () => clearTimeout(timer);
            }
        } else {
            setIsChecking(false);
        }
    }, [isLogined]);

    const reloadPage = () => {
        navigate(0);
        window.scrollTo(0, 0);
    };

    // CTA Tải App — hiện ở cả trạng thái guest & logged-in, dẫn về /tai-app.
    // Icon luôn hiện; chữ "Tải App" ẩn trên màn cực nhỏ để tránh chật (hiện từ sm trở lên).
    const downloadAppBtn = (
        <Link
            to="/tai-app"
            className="bg-gradient-to-r from-brand-red to-brand-warm hover:opacity-90 py-2 px-2 text-white text-xs font-semibold rounded-lg flex items-center gap-1.5 transition-all active:scale-95"
        >
            <FontAwesomeIcon icon={faDownload} />
            <span className="hidden sm:inline">Tải App</span>
        </Link>
    );

    // Shared logo brand — used on both home (reload) and sub-pages (link)
    const logoBrand = (
        <div className="h-full flex items-center rounded-lg hover:bg-surface-muted">
            <img className="h-full object-cover" src="/img/brand-logo/longhousee.png" alt="logo" />
            <div className="font-lexend flex flex-col justify-center items-start text-left text-sm font-bold leading-4 text-brand-coral">
                <span className="px-1">SĂN SALE CÙNG</span>
                <span className="px-1">LONGHOUSEE</span>
            </div>
        </div>
    );

    return (
        <header className="h-16 fixed top-0 left-0 right-0 w-full border-b shadow-sm bg-surface z-50">
            <div className="h-full flex items-center justify-between py-2 px-4 md:w-[768px] lg:w-[1024px] mx-auto">

                {/* Logo — home page reloads, other pages navigate to "/" */}
                {!hasBackButton && pathName === "/" && (
                    <div onClick={reloadPage} className="h-full flex items-center font-semibold cursor-pointer">
                        {logoBrand}
                    </div>
                )}
                {!hasBackButton && pathName !== "/" && (
                    <Link to="/" className="h-full flex items-center font-semibold">
                        {logoBrand}
                    </Link>
                )}

                {/* Back button */}
                {hasBackButton && (
                    <Link to={redirectPath || "/"} className="flex items-center gap-1 hover:bg-surface-raised py-2 px-2 rounded-lg">
                        <FontAwesomeIcon icon={faChevronLeft} />
                        <span className="text-sm font-semibold">Trở lại</span>
                    </Link>
                )}

                {/* Right side: bell + menu OR login/signup */}
                <div className="h-2/3">
                    {/* Placeholder to prevent layout shift during auth check */}
                    {isChecking && <div className="h-full w-32" />}

                    {!isChecking && isLogined && userInfo && (
                        <div className="flex h-full items-center gap-3">
                            {downloadAppBtn}
                            <ThemeToggle className="hidden sm:flex" />
                            <Bell notiList={userInfo.notifications || []} />
                            <FontAwesomeIcon
                                onClick={() => setIsOpenMenu(true)}
                                icon={faBars}
                                className="text-2xl cursor-pointer"
                            />
                        </div>
                    )}

                    {!isChecking && !isLogined && (
                        <div className="flex items-center h-full gap-2">
                            {downloadAppBtn}
                            <ThemeToggle className="hidden sm:flex" />
                            <Link to="/signup" className="bg-blue-500 hover:bg-blue-600 py-2 px-2 text-white text-xs font-semibold rounded-lg flex items-center gap-1.5 transition-colors">
                                <FontAwesomeIcon icon={faUserPlus} />
                                Đăng ký
                            </Link>
                            <Link to="/login" className="bg-green-500 hover:bg-green-600 py-2 px-2 text-white text-xs font-semibold rounded-lg flex items-center gap-1.5 transition-colors">
                                <FontAwesomeIcon icon={faSignInAlt} />
                                Đăng nhập
                            </Link>
                        </div>
                    )}
                </div>
            </div>

            <MainMenu isOpen={isOpenMenu} setOpen={setIsOpenMenu} />
        </header>
    );
}

export default Header;
